import React from 'react';
import { translate, locale } from 'base/shared/Localization';
import { getPublicAsset } from 'base/shared/Utils';
import { getDeviceOsFromStore } from 'datamodel/Device/selectors';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Image from 'components/Image/Image';

const FloatingChatBubbleWrapper = styled.div`
  position: absolute;
  z-index: 10;
  cursor: pointer;
  top: -70px;
  right: 20px;
`;

const FloatingChatBubble = ({
  room,
  moveIn = null,
  moveOut = null,
  guestParams = null,
  currentUserEmail = null,
}) => {
  const os = useSelector(getDeviceOsFromStore);
  const isIOS = os === 'iOS';
  const isAndroid = os === 'Android';

  const roomName = room.title;
  const number = '34635843056';
  const textEn = `
                  Hi! I'm interested in ${roomName}.
                  Check-in date: ${moveIn || ''}
                  Check-out date: ${moveOut || ''}
                  Can you provide me with more information about it?
                  
                  My email address: ${currentUserEmail || guestParams?.guestEmail}
                 `.replace(/^ +/gm, '');
  const textEs = `
                  ¡Hola! Estoy interesado en ${roomName}.
                  Fecha de entrada: ${moveIn || ''}
                  Fecha de salida: ${moveOut || ''}
                  ¿Podrían proporcionarme más información?

                  Mi correo electrónico: ${currentUserEmail || guestParams?.guestEmail || ''}
                 `.replace(/^ +/gm, '');

  const encodedText = encodeURIComponent(locale().match(/en/) ? textEn : textEs);
  const url = `https://wa.me/${number}?text=${encodedText}`;
  const mobileUrl = `whatsapp://send?phone=${number}?text=${encodedText}`;
  const agentStyle = {
    borderRadius: '50%',
    width: '60px',
    height: '60px',
    border: '2px solid white',
    boxShadow: 'rgba(0, 0, 0, 0.3) 2px 2px 10px',
  };
  const iconStyle = {
    position: 'absolute',
    width: '27px',
    top: '-10px',
    right: '-4px',
  };

  const handleFloatingChatClick = () => {
    if (isIOS || isAndroid) {
      const originalUrl = window.location.href;
      window.location.href = mobileUrl;

      setTimeout(() => {
        window.location.href = originalUrl;
      }, 3000);
    } else {
      window.open(url, '_blank').focus();
    }
  };

  return (
    <FloatingChatBubbleWrapper onClick={handleFloatingChatClick}>
      <Image src={getPublicAsset('icons/badiplus-checkout/chat_icon.svg')} styles={iconStyle} />
      <Image src={getPublicAsset('images/julia.png')} styles={agentStyle} />
    </FloatingChatBubbleWrapper>
  );
};

export default FloatingChatBubble;
